// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  arrow_icon,
  delete_icon,
  edit_icon,
  Search_icon,
} from "../../assets/img";
import { toast } from "react-toastify";
import { Table } from "../../components/Table/Table";
import Topbar from "../../components/Topbar/Topbar";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { get, patch, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import Loader from "../../components/Loader";

// master "type" id for room tags
const ROOM_TAG_TYPE = 53;

const RoomTags = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  // TODO: status toggle is local only until its API is ready
  const [types, setTypes] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState({});
  const [addPopup, setAddPopup] = useState(false);
  const [popup, setPopup] = useState(false);
  const [type, setType] = useState("add");
  const [editId, setEditId] = useState(null);
  const [name, setName] = useState("");
  const [policy, setPolicy] = useState("");
  const [names, setNames] = useState([]);
  const [errors, setErrors] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchList = async (pageNumber = 1) => {
    setLoading(true);
    try {
      const res = await get(
        `${URLS.MASTERURL}?type=${ROOM_TAG_TYPE}&page=${pageNumber}&search=${encodeURIComponent(search.trim())}`,
      );
      if (res?.status === "success") {
        setTypes(res?.data || []);
        setTotalCount(res?.count ?? res?.data?.length ?? 0);
        setPagination({
          current_page: pageNumber,
          last_page: res?.total_pages ?? Math.ceil((res?.count || 0) / 10),
        });
      }
    } catch (err) {
      console.error("Failed to fetch room tags:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList(page);
  }, [search, page]);

  const closeAddPopup = () => {
    setAddPopup(false);
    setName("");
    setPolicy("");
    setNames([]);
    setErrors(false);
    setEditId(null);
  };

  // add the typed text to the list of names (multi add)
  const handleKeyPress = (e) => {
    e.preventDefault();
    if (policy.trim() !== "") {
      setNames([...names, policy.trim()]);
      setPolicy("");
      setErrors(false);
    }
  };

  const handleDelete = (index) => {
    setNames((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    if (type === "add") {
      if (names.length === 0) {
        setErrors(true);
        return;
      }
      if (policy.trim() !== "") {
        toast.error("Please add entered data");
        return;
      }
      // already existing names (case-insensitive)
      const existingNames = names.filter((n) =>
        types.some((item) => item.name.toLowerCase() === n.toLowerCase()),
      );
      if (existingNames.length > 0) {
        toast.error(`Already exists: ${existingNames.join(", ")}`);
        return;
      }
      // duplicates inside the new names
      const lowerCaseNames = names.map((n) => n.toLowerCase());
      const duplicateNames = names.filter(
        (n, i) => lowerCaseNames.indexOf(n.toLowerCase()) !== i,
      );
      if (duplicateNames.length > 0) {
        toast.error(`Duplicates inside names: ${duplicateNames.join(", ")}`);
        return;
      }
      setLoading(true);
      try {
        const res = await post(`${URLS.MASTERURL}add/`, {
          type: ROOM_TAG_TYPE,
          name: names,
        });
        if (res?.status !== "success") {
          // a 2xx "failure" response doesn't toast anywhere else, so show it here
          if (res?.status) {
            const fieldErrors = res?.errors
              ? Object.values(res.errors).flat().join(", ")
              : "";
            toast.error(res?.message || fieldErrors || "Failed to add");
          }
          return;
        }
        toast.success(res?.message || "Added successfully");
        fetchList(page);
      } catch (err) {
        console.error(err);
        return;
      } finally {
        setLoading(false);
      }
    } else {
      if (!name.trim()) {
        setErrors(true);
        return;
      }
      // same name already used by another tag (case-insensitive)
      if (
        types.some(
          (item) =>
            item.id !== editId &&
            item.name.toLowerCase() === name.trim().toLowerCase(),
        )
      ) {
        toast.error(`Already exists: ${name.trim()}`);
        return;
      }
      setLoading(true);
      try {
        const res = await patch(`${URLS.MASTERURL}${editId}/edit/`, {
          name: name.trim(),
        });
        if (res?.status !== "success") {
          if (res?.status) {
            const fieldErrors = res?.errors
              ? Object.values(res.errors).flat().join(", ")
              : "";
            toast.error(res?.message || fieldErrors || "Failed to edit");
          }
          return;
        }
        toast.success(res?.message || "Edited successfully");
        fetchList(page);
      } catch (err) {
        console.error(err);
        return;
      } finally {
        setLoading(false);
      }
    }
    closeAddPopup();
  };

  const handleStatus = async ({ id, is_mapped }) => {
    if (is_mapped) {
      toast.error(
        "This room tag is mapped to a property and cannot be deactivated.",
      );
      return;
    }
    let url = `${URLS.MASTERURL}${id}/status/`;
    let res = await post(url);
    if (res?.status === "success") {
      toast.success(res?.message);
      setTypes((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, status: !item.status } : item,
        ),
      );
      fetchList(page);
    }
  };

  const handleDeleteList = async () => {
    if (!editId) return;
    setLoading(true);
    try {
      const res = await post(`${URLS.MASTERURL}${editId}/delete/`);
      if (res?.status === "success") {
        toast.success(res?.message || "Deleted successfully");
        setPopup(false);
        setEditId(null);
        // go back a page if the last row of a later page was deleted
        const nextPage = types.length === 1 && page > 1 ? page - 1 : page;
        if (nextPage !== page) setPage(nextPage);
        else fetchList(page);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "Room Tag",
        accessor: "name",
        Cell: ({ value }) => <p>{value}</p>,
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => (
          <div>
            <button
              onClick={() => handleStatus(row.original)}
              className={`${
                value !== "Active" ? "deactive-btn" : "active-btn"
              } border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18`}
            >
              {value !== "Active" ? "De-active" : " Active"}
            </button>
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ row }) => (
          <div className="d-flex ac-js gap-3">
            <button
              onClick={() => {
                setType("edit");
                setEditId(row.original.id);
                setName(row.original.name);
                setAddPopup(true);
              }}
              className="cust-btn "
            >
              <img src={edit_icon} alt="" className=" edit-btn " />
            </button>
            <button
              onClick={() => {
                setEditId(row.original.id);
                setPopup(true);
              }}
              className="cust-btn "
            >
              <img src={delete_icon} alt="" className=" edit-btn " />
            </button>
          </div>
        ),
      },
    ],
    [page],
  );

  return (
    <div>
      <Topbar header={"Master"} subHead={"Room Tag"} />
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total: {totalCount}
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={Search_icon} className="search" alt="search" />
          </div>
          <button
            onClick={() => {
              setType("add");
              setAddPopup(true);
            }}
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
          >
            + Add New
          </button>
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={types}
        show={true}
      />

      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {type === "add" ? "Add" : "Edit"}
              </p>
              <CloseSharpIcon onClick={closeAddPopup} className="pointer" />
            </div>
            <div className="d-flex ac-js mt-3">
              <div className="w-100">
                <div className="d-flex ac-jb mb-3">
                  <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
                    Enter Room Tag
                  </p>
                </div>
                {type === "add" && (
                  <div>
                    <div className="d-flex ae-jb input-border p-1">
                      <textarea
                        style={{ maxHeight: "80px" }}
                        value={policy}
                        onChange={(e) =>
                          setPolicy(e.target.value.replace(/,/g, ""))
                        }
                        placeholder="Write Here...."
                        className="border-0 mb-3 w-80"
                      />
                      <button
                        onClick={handleKeyPress}
                        className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 p-1"
                        style={{ minWidth: "100px" }}
                      >
                        Add
                      </button>
                    </div>
                    {errors && (
                      <p className="err text-start">
                        Please add at least one room tag.
                      </p>
                    )}
                    {names.length > 0 && (
                      <ul
                        className="input-border overflow-scroll mt-2"
                        style={{ minHeight: "50px", maxHeight: "200px" }}
                      >
                        {names.map((item, index) => (
                          <li key={index} className="d-flex as-js gap-3 mt-2">
                            <img
                              src={arrow_icon}
                              className="bullet-btn"
                              alt=""
                            />
                            <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 w-80 text-start">
                              {item}
                            </p>
                            <img
                              src={delete_icon}
                              className="delete-btn"
                              onClick={() => handleDelete(index)}
                              alt="delete"
                            />
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
                {type === "edit" && (
                  <div>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value.replace(/,/g, ""));
                        setErrors(false);
                      }}
                      placeholder="Room Tag"
                      className="input-box"
                    />
                    {errors && (
                      <p className="err text-start">
                        Please enter the room tag.
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex ac-je px-2 mt-4">
              <button
                onClick={handleSubmit}
                className="submit-btn f2 w-20 p-2 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={handleDeleteList} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => setPopup(false)}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
      {loading && <Loader />}
    </div>
  );
};

export default RoomTags;
